import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Science = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-white" data-id="element-258">
      <div className="container mx-auto px-3 md:px-8" data-id="element-259">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-260">
          <h2 className="text-base md:text-xl font-bold" data-id="element-261">
            {t('science.header')}
          </h2>
        </div>
        <p className="text-lg md:text-xl text-gray-800 mb-4 md:mb-6" data-id="element-262">
          {t('science.intro')}
        </p>
        <div className="bg-blue-50 p-4 md:p-6 rounded-lg mb-6 md:mb-10" data-id="element-263">
          <p className="text-lg md:text-xl font-bold text-center mb-4" data-id="element-264">
            {t('science.formula')}
          </p>
        </div>
        <div className="mb-6 md:mb-10" data-id="element-265">
          <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6" data-id="element-266">
            {t('science.whenTitle')}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-267">
            {[t('science.benefit1'), t('science.benefit2'), t('science.benefit3'), t('science.benefit4'), t('science.benefit5'), t('science.benefit6')].map((benefit, index) => <div key={index} className="flex items-start" data-id="element-268">
                <span className="text-green-500 mr-2 md:mr-3 mt-1" data-id="element-269">
                  <Check size={18} data-id="element-270" />
                </span>
                <span className="text-sm md:text-base text-gray-700" data-id="element-271">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
        <p className="text-base md:text-lg text-gray-700" data-id="element-272">
          {t('science.outro')}
        </p>
      </div>
    </section>;
};